module.exports = "../../static/fonts/HELR65W.ade1cd8.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/HELR65W.woff
// module id = 1623
// module chunks = 1